var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrianglePattern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184.768,
    height: 186.38,
    viewBox: "0 0 184.768 186.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171812",
    "data-name": "\\uADF8\\uB8F9 171812",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-2",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 10.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-2",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-2",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-3",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 10.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-3",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-3",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-4",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 21.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-4",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-4",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-5",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 21.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-5",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-5",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-6",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 21.485)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-6",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-6",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-7",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 32.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-7",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-7",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-8",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 32.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-8",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-8",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-9",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 32.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-9",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-9",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-10",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 32.227)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-10",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-10",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-11",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 42.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-11",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-11",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-12",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 42.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-12",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-12",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-13",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 42.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-13",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-13",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-14",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 42.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-14",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-14",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-15",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 42.969)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-15",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-15",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-16",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 53.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-16",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-16",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-17",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 53.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-17",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-17",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-18",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 53.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-18",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-18",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-19",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 53.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-19",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-19",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.611,
    r: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-20",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 53.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-20",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-20",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-21",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 53.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-21",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-21",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-22",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(118.166 65.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-22",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-22",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-23",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 65.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-23",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-23",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-24",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 65.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-24",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-24",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-25",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 65.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-25",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-25",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-26",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 65.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-26",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-26",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-27",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 65.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-27",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-27",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-28",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 65.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-28",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-28",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-29",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(107.424 76.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-29",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-29",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-30",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(118.166 76.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-30",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-30",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-31",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 76.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-31",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-31",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-32",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 76.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-32",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-32",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-33",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 76.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-33",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-33",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-34",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 76.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-34",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-34",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-35",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 76.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-35",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-35",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-36",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 76.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-36",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-36",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-37",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(97.219 86.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-37",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-37",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-38",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(107.424 86.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-38",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-38",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-39",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(118.166 86.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-39",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-39",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-40",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 86.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-40",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-40",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-41",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 86.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-41",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-41",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-42",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 86.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-42",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-42",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-43",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 86.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-43",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-43",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-44",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 86.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-44",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-44",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-45",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 86.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-45",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-45",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-46",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(97.219 97.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-46",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-46",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-47",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(107.424 97.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-47",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-47",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-48",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(118.166 97.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-48",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-48",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-49",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 97.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-49",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-49",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-50",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 97.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-50",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-50",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-51",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 97.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-51",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-51",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-52",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 97.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-52",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-52",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-53",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 97.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-53",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-53",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-54",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 97.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-54",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-54",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-55",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(97.219 107.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-55",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-55",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-56",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(107.424 107.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-56",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-56",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-57",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(118.166 107.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-57",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-57",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-58",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 107.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-58",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-58",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-59",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 107.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-59",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-59",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-60",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 107.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-60",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-60",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-61",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 107.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-61",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-61",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-62",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 107.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-62",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-62",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-63",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 107.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-63",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-63",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-64",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(97.219 118.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-64",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-64",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-65",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(107.424 118.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-65",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-65",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-66",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(118.166 118.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-66",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-66",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-67",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 118.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-67",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-67",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-68",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 118.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-68",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-68",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-69",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 118.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-69",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-69",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-70",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 118.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-70",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-70",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-71",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 118.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-71",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-71",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-72",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 118.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-72",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-72",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-73",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(97.219 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-73",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-73",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-74",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(107.424 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-74",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-74",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-75",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(118.166 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-75",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-75",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-76",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-76",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-76",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-77",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-77",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-77",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-78",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-78",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-78",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-79",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-79",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-79",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-80",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-80",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-80",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-81",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-81",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-81",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-82",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(97.219 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-82",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-82",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-83",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(107.424 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-83",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-83",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-84",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(118.166 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-84",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-84",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-85",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-85",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-85",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-86",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-86",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-86",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-87",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-87",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-87",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-88",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-88",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-88",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-89",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-89",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-89",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-90",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-90",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-90",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-91",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(97.219 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-91",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-91",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-92",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(107.424 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-92",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-92",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-93",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(118.166 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-93",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-93",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-94",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-94",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-94",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-95",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-95",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-95",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-96",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-96",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-96",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-97",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-97",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-97",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-98",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-98",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-98",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-99",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-99",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-99",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-100",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(97.219 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-100",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-100",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-101",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(107.424 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-101",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-101",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.611,
    r: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-102",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(118.166 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-102",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-102",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-103",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-103",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-103",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-104",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-104",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-104",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-105",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-105",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-105",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-106",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-106",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-106",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.611,
    r: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-107",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-107",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-107",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-108",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-108",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-108",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-109",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(97.219 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-109",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-109",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-110",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(107.424 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-110",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-110",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-111",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(118.166 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-111",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-111",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-112",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-112",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-112",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-113",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-113",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-113",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-114",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-114",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-114",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-115",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-115",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-115",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-116",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-116",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-116",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-117",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-117",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-117",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-118",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(97.219 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-118",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-118",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-119",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(107.424 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-119",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-119",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-120",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(118.166 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-120",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-120",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-121",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(128.908 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-121",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-121",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-122",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(139.651 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-122",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-122",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-123",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(150.393 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-123",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-123",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-124",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(160.599 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-124",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-124",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-125",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(171.34 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-125",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-125",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-126",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(182.083 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-126",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-126",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-127",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(84.865 97.218)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-127",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-127",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-128",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(74.122 107.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-128",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-128",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-129",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(84.865 107.961)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-129",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-129",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-130",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(63.918 118.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-130",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-130",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-131",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(74.122 118.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-131",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-131",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-132",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(84.865 118.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-132",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-132",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-133",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(53.175 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-133",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-133",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-134",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(63.918 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-134",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-134",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-135",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(74.122 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-135",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-135",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-136",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(84.865 130.52)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-136",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-136",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-137",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(42.433 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-137",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-137",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-138",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(53.175 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-138",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-138",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-139",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(63.918 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-139",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-139",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-140",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(74.122 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-140",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-140",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-141",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(84.865 141.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-141",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-141",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-142",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(31.69 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-142",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-142",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-143",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(42.433 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-143",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-143",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-144",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(53.175 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-144",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-144",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-145",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(63.918 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-145",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-145",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-146",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(74.122 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-146",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-146",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-147",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(84.865 152.004)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-147",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-147",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-148",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(20.947 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-148",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-148",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.611,
    r: 1.611,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-149",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(31.69 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-149",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-149",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-150",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(42.433 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-150",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-150",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-151",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(53.175 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-151",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-151",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-152",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(63.918 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-152",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-152",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-153",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(74.122 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-153",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-153",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.611,
    r: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-154",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(84.865 162.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-154",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-154",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.611,
    rx: 1.343,
    ry: 1.611
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-155",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(10.743 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-155",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-155",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-156",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(20.947 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-156",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-156",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-157",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(31.69 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-157",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-157",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-158",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(42.433 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-158",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-158",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-159",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(53.175 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-159",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-159",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-160",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(63.918 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-160",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-160",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-161",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(74.122 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-161",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-161",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-162",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(84.865 172.952)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-162",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-162",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-163",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(0 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-163",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-163",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-164",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(10.743 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-164",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-164",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-165",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(20.947 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-165",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-165",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343,
    transform: "translate(0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-166",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(31.69 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-166",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-166",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-167",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(42.433 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-167",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-167",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-168",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(53.175 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-168",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-168",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-169",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(63.918 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-169",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-169",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-170",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(74.122 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-170",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\\uD0C0\\uC6D0_9366-170",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.611,
    cy: 1.343,
    rx: 1.611,
    ry: 1.343
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_162749-171",
    "data-name": "\\uADF8\\uB8F9 162749",
    transform: "translate(84.865 183.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "company1-1-171",
    "data-name": "company1-1",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\uD0C0\\uC6D0_9366-171",
    "data-name": "\\uD0C0\\uC6D0 9366",
    cx: 1.343,
    cy: 1.343,
    r: 1.343
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrianglePattern);
export default __webpack_public_path__ + "static/media/trianglePattern.eea44bff52283e8ec2491462ee0b685a.svg";
export { ForwardRef as ReactComponent };